import { jsx as _ } from "react/jsx-runtime";
import "react";
import { SportsItem as j } from "./schedule-list-items/SportsItem.js";
import { SeriesItem as w } from "./schedule-list-items/SeriesItem.js";
import { MovieItem as $ } from "./schedule-list-items/MovieItem.js";
import { getMinutesFromStr as k } from "../../utils/helpers.js";
import '../../assets/ScheduleList.css';const g = {
  "schedule-list__item": "_schedule-list__item_10j6g_1",
  "schedule-list__airdate": "_schedule-list__airdate_10j6g_12",
  "schedule-list": "_schedule-list_10j6g_1",
  "fade-in": "_fade-in_10j6g_1",
  "fade-out": "_fade-out_10j6g_1"
}, f = (r) => {
  var o, p, i, a, n, t, v, y, x, b, S;
  return (o = r.video) != null && o.brightcove_id ? {
    label: "Watch Preview",
    type: "play-video",
    href: "",
    relatedResourceId: r.video.brightcove_id,
    position: "inline"
  } : r != null && r.showUpcoming && (r == null ? void 0 : r.program_class) === "Episode" ? {
    label: "",
    //`View Upcoming Airings`
    type: "",
    //'show-modal',
    href: "",
    relatedResourceId: "",
    //determineSeriesPrefix(scheduleItem.series_prefix),
    relatedResourceType: "",
    //'series',
    position: ""
    //'inline',
  } : r != null && r.showUpcoming && (r == null ? void 0 : r.program_class) === "Film" ? {
    label: "",
    //`View Upcoming Airings`,
    type: "",
    //'show-modal',
    href: "",
    relatedResourceId: "",
    //scheduleItem.title_code,
    relatedResourceType: "",
    //'film',
    position: ""
    //'inline',
  } : (((p = r == null ? void 0 : r.content) == null ? void 0 : p.external_link) !== void 0 && ((i = r == null ? void 0 : r.content) == null ? void 0 : i.external_link) !== "" || ((a = r == null ? void 0 : r.content) == null ? void 0 : a.slug) !== void 0 && ((n = r == null ? void 0 : r.content) == null ? void 0 : n.slug) !== "") && !((t = r == null ? void 0 : r.content) != null && t.prevent_detail_page) ? {
    label: (r == null ? void 0 : r.program_class) === "Episode" ? "View Series Details" : (r == null ? void 0 : r.program_class) === "Film" ? "View Movie Details" : "Learn More",
    type: (v = r == null ? void 0 : r.content) != null && v.external_link ? "external-link" : "internal-link",
    href: (y = r == null ? void 0 : r.content) != null && y.external_link ? (x = r == null ? void 0 : r.content) == null ? void 0 : x.external_link : r.program_class === "Episode" ? `/show/${(b = r == null ? void 0 : r.content) == null ? void 0 : b.slug}` : `/movie/${(S = r == null ? void 0 : r.content) == null ? void 0 : S.slug}`,
    position: "inline"
  } : {
    label: "",
    type: "",
    href: "",
    position: ""
  };
};
function A({
  schedule: r = [],
  handleClicks: o = () => !0,
  exiting: p = !1
}) {
  return /* @__PURE__ */ _("ul", { className: `${g["schedule-list"]} schedule-list`, "data-state": p ? "exiting" : "idle", children: r.length !== 0 && r.map((i) => {
    const a = k(i.element_length), n = f(i).type === "" ? [a, i.rating] : [a, i.rating, "&nbsp;"];
    return i.program_class === "Episode" ? /* @__PURE__ */ _(
      w,
      {
        scheduleItem: i,
        styles: g,
        strListArr: n,
        handleClicks: o,
        determineCTA: f
      },
      `schedule-list-${i.id}`
    ) : i.program_class === "Film" || i.program_class === "Movie" || i.program_class === "Special" ? /* @__PURE__ */ _(
      $,
      {
        scheduleItem: i,
        styles: g,
        strListArr: n,
        handleClicks: o,
        determineCTA: f
      },
      `schedule-list-${i.id}`
    ) : i.program_class === "Sports" ? /* @__PURE__ */ _(
      j,
      {
        scheduleItem: i,
        styles: g,
        strListArr: n,
        handleClicks: o,
        determineCTA: f
      },
      `schedule-list-${i.id}`
    ) : null;
  }) });
}
export {
  A as ScheduleList,
  A as default
};
